import { injectContentsquareScript } from '@contentsquare/tag-sdk';

interface UserAttributes {
  userId: string;
  email: string;
  role: string;
  name: string;
  lastName: string;
}

class ContentsquareService {
  private static instance: ContentsquareService;
  private initialized: boolean = false;

  private constructor() {
    this.initializeContentsquare();
  }

  public static getInstance(): ContentsquareService {
    if (!ContentsquareService.instance) {
      ContentsquareService.instance = new ContentsquareService();
    }
    return ContentsquareService.instance;
  }

  private initializeContentsquare() {
    if (!this.initialized) {
      injectContentsquareScript({
        siteId: "5276981",
        async: true,
        defer: false
      });
      this.initialized = true;
    }
  }

  public setUserAttributes(attributes: Partial<UserAttributes>) {
    if (typeof window !== 'undefined' && (window as any)._uxa) {
      const { userId, email, role, name, lastName } = attributes;

      // Set user ID
      if (userId) {
        (window as any)._uxa.push(['setUserId', userId]);
      }

      // Set user attributes
      const userVars: Record<string, string> = {};
      
      if (email) userVars['email'] = email;
      if (role) userVars['role'] = role;
      if (name) userVars['name'] = name;
      if (lastName) userVars['lastName'] = lastName;

      if (Object.keys(userVars).length > 0) {
        (window as any)._uxa.push(['setUserVars', userVars]);
      }
    }
  }

  public clearUserAttributes() {
    if (typeof window !== 'undefined' && (window as any)._uxa) {
      (window as any)._uxa.push(['setUserId', null]);
      (window as any)._uxa.push(['setUserVars', {}]);
    }
  }
}

export const contentsquareService = ContentsquareService.getInstance();
